window.swiperList = [];
var moneyFormat = window.price.money_format || '${{amount}}';

function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number) {
        var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
        var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

function extractSectionId(element) {
    element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
    return element.id.replace("shopify-section-", "");
}

function getUrlWithVariant(url, id) {
    if (/variant=/.test(url)) {
        return url.replace(/(variant=)[^&]+/, '$1' + id);
    } else if (/\?/.test(url)) {
        return url.concat('&variant=').concat(id);
    }

    return url.concat('?variant=').concat(id);
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`,
            'X-Requested-With': 'XMLHttpRequest'
        }
    };
}

(function updateCartCount() {
    const counterEl = document.getElementById("cart-counter-element");

    const getCartItemsCount = async () => {
        const response = await fetch(`${routes.cart_url}.json`, {
            method: "GET",
            headers: {
                'Accept': 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        const data = await response.json();

        return data.item_count;
    }
    
    document.addEventListener("cart:updated", async () => {
        const countValue = await getCartItemsCount()

        if (counterEl) {
            if (countValue > 0) {
                if (!counterEl.classList.contains("show")) counterEl.classList.add("show")
            } else {
                counterEl.classList.remove("show")
            }

            counterEl.textContent = countValue;
        }
    })
})();

class SliderComponent extends HTMLElement {
    constructor() {
        super();

        this.swiper;
        this.sliderContainer = this.querySelector("[data-swiper-element]");
        this.paginationElement = this.querySelector("[data-swiper-pagination-element]");
        this.optionName = this.getAttribute("data-swiper-option-name");
        this.swiperOptionItem = swiperOptions.find((optionItem) => optionItem.name === this.optionName);
        this.additionalOptions = this.swiperOptionItem.options;
    }

    connectedCallback() {
        this.buttonPrevElement = this.querySelector("[data-swiper-button-prev]") || this.closest("section")?.querySelector("[data-swiper-button-prev]");
        this.buttonNextElement = this.querySelector("[data-swiper-button-next]") || this.closest("section")?.querySelector("[data-swiper-button-next]");

        this.options = {
            slidesPerView: "auto",
            spaceBetween: 0,
            navigation: {
                nextEl: this.buttonNextElement,
                prevEl: this.buttonPrevElement,
            },
            pagination: {
                el: this.paginationElement,
                clickable: true,
                bulletClass: "slider-component__pagination-item",
                bulletActiveClass: "slider-component__pagination-item--active"
            },
            ...this.additionalOptions
        }

        if (!this.sliderContainer) return;

        this.initSwiper();
    }

    initSwiper() {
        this.swiper = new Swiper(this.sliderContainer, this.options);
    }

    getSwiper() {
        return this.swiper
    }
}

if (!window.customElements.get("slider-component")) {
    window.customElements.define("slider-component", SliderComponent)
}

class ShowMoreToggler extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.content = this.querySelector("[data-show-more-content]");
        this.button = this.querySelector("[data-show-more-button]");

        setTimeout(() => {
            this.checkButtonDisplay();
        }, 0)

        this.button.addEventListener("click", (event) => {
            const eventTarget = event.target;

            if (eventTarget.closest("[data-show-more-button]")) {
                this.content.classList.toggle("line-clamp");
                this.button.classList.toggle("open");
                this.replaceButtonText();
            }
        });
    }

    checkButtonDisplay() {
        if (this.button) {
            if (this.content.offsetHeight < 300) {
                this.button.classList.toggle("hidden");
            } else {
                this.button.classList.remove("hidden");
            }
        }
    }

    replaceButtonText() {
        if (this.button.classList.contains("open")) {
            this.button.innerText = `${window.translations.product.buttons.show_less}`;
        } else {
            this.button.innerText = `${window.translations.product.buttons.show_more}`;
        }
    }
}

if (!window.customElements.get("show-more-toggler")) {
    window.customElements.define("show-more-toggler", ShowMoreToggler);
}

class RecipientFields extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.fields = this.querySelectorAll("[data-recipient-field]");
        this.checkbox = this.querySelector("[data-recipient-checkbox]");
        this.checkbox.disabled = false;
        this.hiddenControlField = this.querySelector("[data-recipient-control]");
        this.hiddenControlField.disabled = true;
        this.fieldsWrapper = this.querySelector("[data-recipient-fields]");
        this.recipientTimezone = this.querySelector("[data-recipient-timezone]");
        if (this.recipientTimezone) this.recipientTimezone.value = new Date().getTimezoneOffset().toString();
        this.onChange();
        this.addEventListener("change", (event) => {
            const eventTarget = event.target;

            if (eventTarget.closest("[data-recipient-checkbox]")) {
                this.onChange();
            }
        });
    }

    onChange() {
        if (this.checkbox.checked) {
            if (!this.fieldsWrapper.classList.contains("show")) {
                this.fieldsWrapper.classList.add("show");
            }
            this.enableFields();
        } else {
            this.fieldsWrapper.classList.remove("show");
            this.disableFields();
            this.clearFields();
        }

        this.recipientTimezone.disabled = !this.checkbox.checked;
    }

    disableFields() {
        [...this.fields].map((field) => { field.disabled = true; })
    }

    enableFields() {
        [...this.fields].map((field) => { field.disabled = false; })
    }

    clearFields() {
        [...this.fields].map((field) => { field.value = ""; })
    }
}

if (!window.customElements.get("recipient-fields")) {
    window.customElements.define("recipient-fields", RecipientFields);
}

class BeforeAfterImage extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.range = this.querySelector(".js-before-after-range");
        this.button = this.querySelector(".js-before-after-button");
        this.resizeContainer = this.querySelector(".js-before-after-resize");
        this.coverImage = this.querySelector(".js-before-after-cover");

        this.shakeInput()
        this.updateComparison(this.range.value);
        this.fixCoverImageSize();

        this.addEventListener("click", (event) => {
            const eventTarget = event.target;

            if (eventTarget.closest(".js-before-after-label-before")) {
                this.range.value = 0;
                this.range.dispatchEvent(new Event("input"));
            }

            if (eventTarget.closest(".js-before-after-label-after")) {
                this.range.value = 100;
                this.range.dispatchEvent(new Event("input"));
            }

            if (!eventTarget.closest(".js-before-after-label-before") && !eventTarget.closest(".js-before-after-label-after")) {
                if (window.innerWidth < 991) {
                    const rect = this.getBoundingClientRect();
                    const offsetY = event.clientY - rect.top;
                    const percentage = (offsetY / rect.height) * 100;
                    const clampedPercentage = Math.max(0, Math.min(100, percentage));
                    this.updateComparison(clampedPercentage)
                }
            }
        });

        this.range.addEventListener("input", () => {
            this.updateComparison(this.range.value);
        });

        window.addEventListener("resize", () => {
            this.fixCoverImageSize();
            this.updateComparison(this.range.value);
        });
    }

    shakeInput() {
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!this.classList.contains("initialized")) {
                        setTimeout(() => {
                            if(!this.button.classList.contains("transition")) this.button.classList.add("transition");
                            if(!this.resizeContainer.classList.contains("transition")) this.resizeContainer.classList.add("transition")
                            this.range.value = 52;
                            this.range.dispatchEvent(new Event("input"));
                        }, 300)

                        setTimeout(() => {
                            this.range.value = 48;
                            this.range.dispatchEvent(new Event("input"));
                        }, 600);

                        setTimeout(() => {
                            this.range.value = 50;
                            this.range.dispatchEvent(new Event("input"));
                            
                            setTimeout(() => {
                                this.button.classList.remove("transition");
                                this.resizeContainer.classList.remove("transition");
                            }, 300)
                        }, 900);

                        this.classList.add("initialized")
                    }
                }
            })
        }

        const observer = new IntersectionObserver(callback, {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        });

        observer.observe(this)
    }

    updateComparison(value) {
        if (!this.resizeContainer || !this.button) return;

        if (window.innerWidth > 991) {
            this.resizeContainer.style.width = `${value}%`;
            this.resizeContainer.style.height = `100%`;
            this.button.style.left = `${value}%`;
            this.button.style.top = `50%`;
            this.range.removeAttribute("orient");
        } else {
            this.resizeContainer.style.width = `100%`;
            this.resizeContainer.style.height = `${value}%`;
            this.button.style.left = `50%`;
            this.button.style.top = `${value}%`;
            this.range.setAttribute("orient", "vertical");
        }
    }

    fixCoverImageSize() {
        const width = this.offsetWidth;
        const height = this.offsetHeight;

        if (!this.coverImage || !width || !height) return;

        if (window.innerWidth > 991) {
            this.coverImage.style.width = `${width}px`;
            this.coverImage.style.height = `${height}px`;
        } else {
            this.coverImage.style.height = `${height}px`;
            this.coverImage.style.width = `${width}px`;
        }
    }
}

if (!window.customElements.get("before-after-image")) {
    window.customElements.define("before-after-image", BeforeAfterImage);
}

class CollapsibleRow extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initEvents();
    }

    initEvents() {
        this.addEventListener("click", event => {
            const eventTarget = event.target;

            if (!eventTarget.hasAttribute("data-accordion-button")) {
                return;
            }
            const accordionItem = eventTarget.closest("[data-accordion-item]");

            if (accordionItem.classList.contains("open")) {
                this.close(accordionItem);
            }
            else {
                this.open(accordionItem);
            }
        })
    }

    open(accordionItem) {
        accordionItem.classList.add("open");
    }

    close(accordionItem) {
        accordionItem.classList.remove("open");
    }
}

if (!window.customElements.get("collapsible-row")) {
    window.customElements.define("collapsible-row", CollapsibleRow)
}

class VideoContent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initElements();
        this.initEvents();
    }

    initElements() {
        this.template = this.querySelector(".js-media-template");
        this.playButtons = this.querySelectorAll(".js-play-button");
    }

    initEvents() {
        this.playButtons.forEach(button => {
            button.addEventListener("click", () => {
                const content = document.createElement("div");

                content.appendChild(
                    this.template.content.firstElementChild.cloneNode(true)
                );

                if (content.querySelector(".js-media-content")) {
                    this.innerHTML = content.innerHTML;

                    this.classList.toggle("no-pseudo");
                    this.classList.toggle("no-radius");
                }
            });
        })
    }
}

if (!window.customElements.get("video-content")) {
    window.customElements.define("video-content", VideoContent);
}

class CountdownTimer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.date = new Date(this.getAttribute("data-timer-date"));
        this.initElements();
        this.initEvents();
    }

    initElements() {
        this.daysWrapper = this.querySelector("[data-timer-days-counter]");
        this.hoursWrapper = this.querySelector("[data-timer-hours-counter]");
        this.minutesWrapper = this.querySelector("[data-timer-minutes-counter]");
        this.secondsWrapper = this.querySelector("[data-timer-seconds-counter]");
    }

    tick() {
        this.now = new Date();
        this.deff = (this.date - this.now) / 1000;

        this.days = Math.floor(this.deff / 60 / 60 / 24);
        this.hours = Math.floor((this.deff / 60 / 60) % 24);
        this.minutes = Math.floor((this.deff / 60) % 60);
        this.seconds = Math.floor(this.deff % 60);

        this.daysWrapper.innerHTML = this.days < 0 ? 0 : this.days;
        this.hoursWrapper.innerHTML = this.hours < 0 ? 0 : this.hours;
        this.minutesWrapper.innerHTML = this.minutes < 0 ? 0 : this.minutes;
        this.secondsWrapper.innerHTML = this.seconds < 0 ? 0 : this.seconds;
    }

    initEvents() {
        this.interval = setInterval(() => {
            this.tick();
        }, 1000);
    }
}

if (!window.customElements.get("countdown-timer")) {
    window.customElements.define("countdown-timer", CountdownTimer);
}

class MarqueeText extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();

        const debouncedOnResize = debounce(() => {
            this.clearClones();
            this.init();
        }, 300);

        if (!Shopify.designMode) {
            window.addEventListener("resize", debouncedOnResize);
        }
    }

    init() {
        let cloneLimit = 0;
        const movingMode = this.dataset.movingMode;
        const container = this.querySelector("[data-marquee-container]");
        const content = container.innerHTML;
        const parser = new DOMParser();
        const contentNodes = parser.parseFromString(content, "text/html").querySelectorAll(".marquee-text__item");
        const cloneContainer = document.createElement("div");

        if (!container) return;

        cloneLimit = this.getCloneCount(container);

        if (movingMode !== "marquee") {
            cloneLimit *= 3;
        }

        for (let i = 0; i <= cloneLimit; i++) {
            [...contentNodes].forEach(child => {
                child.classList.add("marquee-clone-element");
                container.appendChild(child.cloneNode(true));
            });
        }

        cloneContainer.innerHTML = "";
        cloneContainer.innerHTML = container.innerHTML;
        cloneContainer.classList.add("marquee-text__container", "no-js-hidden", "marquee-clone-element");
        cloneContainer.setAttribute("data-marquee-container", "");

        this.appendChild(cloneContainer);

        if (this.getAttribute("data-moving-mode") === "marquee") {
            this.enableMarquee();
        } else {
            this.enableScroller(container);
        }
    }

    getCloneCount(container) {
        return Math.ceil(window.innerWidth / container.offsetWidth);
    }

    clearClones() {
        const marqueeList = this.querySelectorAll(".marquee");
        const marqueeCloneList = this.querySelectorAll(".marquee-clone-element");

        [...marqueeList].map((element) => { element.classList.remove("marquee") });
        [...marqueeCloneList].map((element) => { element.remove() });
    }

    enableMarquee() {
        const marqueeContainerList = this.querySelectorAll("[data-marquee-container]");

        [...marqueeContainerList].map((item) => {
            item.classList.add("marquee");
        });
    }

    disableMarquee() {
        const marqueeContainerList = this.querySelectorAll("[data-marquee-container]");

        [...marqueeContainerList].map((item) => {
            item.classList.remove("marquee");
        });
    }

    disconnectedCallback() {
        this.disableMarquee();
        this.clearClones();
    }

    enableScroller(container) {
        const scrollerEasing = this.getAttribute("data-scroller-easing");
        const scrollerDelay = this.getAttribute("data-scroller-delay");
        const handleOnScroll = () => {
            this.horizontalScroll(container);
        }

        container.style.transition = `transform ${scrollerDelay}s ${scrollerEasing}`;

        const observer = new IntersectionObserver(
            (entry) => {
                if (entry[0].isIntersecting) {
                    window.addEventListener("scroll", handleOnScroll);
                } else {
                    window.removeEventListener("scroll", handleOnScroll);
                }
            }, { threshold: 1 }
        );

        observer.observe(this);
    }

    horizontalScroll(container) {
        container.style.transform = `translateX(${-(window.innerHeight - container.getBoundingClientRect().bottom)}px)`;
    }
}

if (!window.customElements.get("marquee-text")) {
    window.customElements.define("marquee-text", MarqueeText);
}

class ProductCollage extends HTMLElement {
    constructor() {
        super();

        this.debounced = debounce(() => {
            this.calculateHeight();
            this.scrollIntoView({ block: "center" });
            this.updateAosAnimation();
        }, 300)
    }

    connectedCallback() {
        window.addEventListener("resize", this.calculateHeight.bind(this));

        if (Shopify.designMode) {
            this.debounced();
        } else {
            this.calculateHeight();
        }
    }

    updateAosAnimation() {
        const aosList = this.querySelectorAll("[data-aos]");

        [...aosList].map(item => item.classList.remove("aos-animate"));

        setTimeout(() => {
            [...aosList].map(item => item.classList.add("aos-animate"));
        }, 0)
    }

    calculateHeight() {
        const collageContainer = this.querySelector("[data-collage-container]");
        const cards = collageContainer.querySelectorAll("[data-collage-item]");
        const top = collageContainer.getBoundingClientRect().top;
        let height = 0;

        if (cards && cards.length) {
            [...cards].forEach(card => {
                const cardHeight = card.getBoundingClientRect().bottom - top;

                if (cardHeight > height) {
                    height = cardHeight
                }
            });

            collageContainer.style.height = `${height }px`;
        }
    }
}

if (!window.customElements.get("product-collage")) {
    window.customElements.define("product-collage", ProductCollage)
}

class PromotionPopup extends HTMLElement {
    constructor() {
        super();

        this.modalElement = this.querySelector("[data-promo-modal]");
        this.backdropElement = this.querySelector("[data-promo-backdrop]");
    }

    connectedCallback() {
        this.setupLocalStorage();

        this.addEventListener("click", (e) => {
            if (e.target.closest("button-close-modal, modal-backdrop")) {
                localStorage.setItem("promo-popup-section", true);
            }
        })
    }

    disconnectedCallback() {
        localStorage.removeItem("promo-popup-section");
    }

    showPopup() {
        const timeToAppearance = this.dataset.timeToAppearance;

        setTimeout(() => {
            document.dispatchEvent(new CustomEvent("modals:open", { detail: { modalId: this.id } }))
        }, +timeToAppearance);
    }

    setupLocalStorage() {
        const stagedValue = localStorage.getItem("promo-popup-section");

        if (!stagedValue) {
            localStorage.setItem("promo-popup-section", false);
            this.showPopup();
        } else {
            if (stagedValue === "false") {
                this.showPopup();
            }
        }
    }
}

if (!window.customElements.get("promotion-popup")) {
    window.customElements.define("promotion-popup", PromotionPopup)
}

class ShopTheLookItem extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.parentContainer = this.closest("[data-shop-the-look-container]");
        this.labelList = this.parentContainer.querySelectorAll("[data-label-id]");
        this.backdrop = this.parentContainer.querySelector("[data-shop-the-look-backdrop]");
        this.label = this.querySelector("[data-label-id]");
        this.itemRect = this.getBoundingClientRect();

        const onSectionVisible = () => {
            this.fixItemSize();
            this.fixItemPosition();
            this.checkItemOverlap();
        }

        const observerOptions = {
            root: null,
            threshold: 0.5
        };
        
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    onSectionVisible();
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);
        
        observer.observe(this.parentContainer);

        const debouncedOnResize = debounce(() => {
            this.fixItemSize();
            this.fixItemPosition();
            this.checkItemOverlap();
            this.checkOverflow();
        }, 600)

        window.addEventListener("resize", debouncedOnResize);

        this.parentContainer.addEventListener("click", (event) => {
            const eventTarget = event.target;

            if (!eventTarget.closest("[data-label-id]") || eventTarget.closest("[data-label-close]")) {
                this.closeLabels();
                this.showBackDrop(false);
                this.checkOverflow();
            }

            if (eventTarget.closest("[data-item-id]")) {
                const itemId = eventTarget.getAttribute("data-item-id");

                this.showLabel(itemId);
                this.showBackDrop(true);
                this.checkOverflow();
            }
        });
    }

    showLabel(itemId) {
        this.labelList.forEach(label => {
            const labelId = label.getAttribute("data-label-id");

            if (labelId === itemId) {
                if (!label.classList.contains("show")) {
                    label.classList.add("show");
                }
            }
        });
    }

    closeLabels() {
        this.labelList.forEach(label => {
            if (label.classList.contains("show")) {
                label.classList.remove("show");
            }
        });
    }

    showBackDrop(show) {
        if (show === true) {
            if (!this.backdrop.classList.contains("show")) {
                this.backdrop.classList.add("show")
            }
        } else {
            if (this.backdrop.classList.contains("show")) {
                this.backdrop.classList.remove("show")
            }
        }
    }

    isOverlapped() {
        return (this.label.getBoundingClientRect().width > this.parentContainer.offsetWidth - (this.getBoundingClientRect().left + (this.label.getBoundingClientRect().width / 3)));
    }

    checkItemOverlap() {
        const isOverlapped = this.isOverlapped();

        if (isOverlapped) {
            if (!this.classList.contains("shop-the-look__item--reverse")) {
                this.classList.add("shop-the-look__item--reverse");
            }
        } else {
            if (this.classList.contains("shop-the-look__item--reverse")) {
                this.classList.remove("shop-the-look__item--reverse");
            }
        }
    }

    fixItemPosition() {
        const itemRect = this.getBoundingClientRect();
        const itemTop = itemRect.top;
        const itemLeft = itemRect.left;
        const itemWidth = itemRect.width;
        const itemHeight = itemRect.height;

        const top = +this.getAttribute("data-vertical-coordinate");
        const left = +this.getAttribute("data-horizontal-coordinate");

        if ((itemLeft + itemWidth) > this.parentContainer.offsetWidth) {
            this.style.left = `calc(${left}% - ${itemWidth}px)`;
        } else {
            this.style.left = `${left}%`;
        }

        if ((itemTop + itemHeight) > this.parentContainer.offsetHeight) {
            this.style.top = `calc(${top}% - ${itemHeight}px)`;
        } else {
            this.style.top = `${top}%`;
        }
    }

    fixItemSize() {
        const labelRect = this.label.getBoundingClientRect();
        const previousHeight = this.itemRect.height;

        if (window.innerWidth >= 768) {
            this.style.height = `${labelRect.height}px`;
        } else {
            this.style.height = `${previousHeight}px`;
        }
    }

    checkOverflow() {
        if (window.innerWidth < 768) {
            new OverflowSwitcher(false);
        }
    }
}

if (!window.customElements.get("shop-the-look-item")) {
    window.customElements.define("shop-the-look-item", ShopTheLookItem);
}

class Share {
    constructor(container) {
        this.selectors = {
            buttonShare: ".js-share-button-share",
            infoCheckbox: ".js-share-info-checkbox",
            infoWrapper: ".js-share-info-wrapper",
            infoField: ".js-share-info-field"
        };
        this.classes = {
            hidden: "hidden"
        };
        try {
            this.container = container;

            this.buttonShare = this.container.querySelector(
                this.selectors.buttonShare
            );
            this.infoCheckbox = this.container.querySelector(
                this.selectors.infoCheckbox
            );
            this.infoWrapper = this.container.querySelector(
                this.selectors.infoWrapper
            );
            this.infoField = this.container.querySelector(this.selectors.infoField);
            this.shareData();
        } catch (error) { }
    }

    shareData() {
        const shareUrl = this.infoField.value;

        if (shareUrl && navigator.share) {
            const shareData = {
                url: shareUrl,
                title: document.title
            };

            this.disableInfo();

            this.buttonShare.addEventListener("click", (e) => {
                e.preventDefault();
                navigator.share(shareData).catch((err) => {
                    console.error("Something went wrong.", err);
                });
            });

            this.infoCheckbox.addEventListener("keydown", (event) => {
                if (event.keyCode === 32) {
                    navigator.share(shareData).catch((err) => {
                        console.error("Something went wrong.", err);
                    });
                }
            });
        } else {
            this.buttonShare.addEventListener("click", () => {
                this.copyToClipboard(shareUrl);
            });

            this.infoWrapper.addEventListener("click", () => {
                this.infoField.focus();
                this.copyToClipboard(shareUrl);
            });
        }
    }

    copyToClipboard(shareUrl) {
        if (shareUrl) {
            navigator.clipboard
                .writeText(shareUrl)
                .then(() => {
                    console.error("Copied to clipboard");
                })
                .catch((err) => {
                    console.error("Something went wrong.", err);
                });
        } else {
            console.error("Something went wrong.");
        }
    }

    disableInfo() {
        if (!this.infoWrapper.classList.contains(this.classes.hidden)) {
            this.infoWrapper.classList.add(this.classes.hidden);
            this.infoField.setAttribute("tabindex", -1);
        }
    }
}

function initShare() {
    const containers = document.querySelectorAll(".js-share-button-container:not(.initialized)");

    if (!containers.length) {
        return null;
    }

    Array.from(containers)
        .filter(function (element) {
            return !element.classList.contains("initialized");
        })
        .forEach(function (element) {
            new Share(element);

            element.classList.add("initialized");
        });
}

initShare();

document.addEventListener("share:init", initShare)

async function fetchWithCache(url) {
    const cacheKey = url;

    if (!document.documentElement.classList.contains("shopify-design-mode")) {
        if (cachedMap.has(cacheKey)) {
            return await (await Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])))).text();
        }
    }

    return fetch(url).then((response) => {
        if (response.status === 200) {
            response.clone().text().then((content) => {
                cachedMap.set(cacheKey, content);
            });
            return response.text();
        }
    });
}

const cachedMap = new Map();
const openElements = new Set();

document.addEventListener("facet:update", async (event) => {
    const url = event.detail.url;
    const shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
    const collectionBody = shopifySection.querySelector("[data-content-element]");
    const collectionFilters = shopifySection.querySelector("[data-collection-filters]");
    const loader = shopifySection.querySelector("[data-collection-loader]");

    if (!loader.classList.contains("show")) {
        loader.classList.add("show")
    }

    shopifySection.querySelectorAll("[data-dropdown-opener]").forEach(element => {
        if (element.open) {
            openElements.add(element.id)
        }
    });

    const clonedUrl = new URL(url);
    clonedUrl.searchParams.delete("section_id");
    history.replaceState({}, "", clonedUrl.toString());
    const sectionResponse = await fetchWithCache(url.toString());
    const tempContent = new DOMParser().parseFromString(await sectionResponse, "text/html");
    const tempCollectionContent = tempContent.querySelector("[data-content-element]");
    const tempCollectionFilters = tempContent.querySelector("[data-collection-filters]");
    const tempProductCount = tempCollectionContent.getAttribute("data-product-count");

    if (tempProductCount) {
        updateCollectionProductCount(tempProductCount);
    }

    collectionBody.replaceChildren(...document.importNode(tempCollectionContent, true).childNodes);
    collectionFilters.replaceChildren(...document.importNode(tempCollectionFilters, true).childNodes);

    if (loader.classList.contains("show")) {
        loader.classList.remove("show")
    }
});

function updateCollectionProductCount(count) {
    const productCountElements = document.querySelectorAll("[data-product-count-html]");

    if (!productCountElements) return;
    if (productCountElements.length <= 0) return;

    productCountElements.forEach(countElement => {
        countElement.innerHTML = count;
    })
}

class PriceRange extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initElements();
        this.initRange();
    }

    initElements() {
        this.abortController = new AbortController();
        this.from = this.querySelector("[data-price-field-from]");
        this.to = this.querySelector("[data-price-field-to]");
        this.sliderOne = this.querySelector("[data-price-range-one]");
        this.sliderTwo = this.querySelector("[data-price-range-two]");

        if (!this.from || !this.to || !this.sliderOne || !this.sliderTwo) {
            return;
        }
    }

    initRange() {
        const minValueFrom = +this.sliderOne.min;
        const minValueTo = +this.sliderTwo.min;

        if (+this.sliderOne.value < minValueFrom) {
            this.sliderOne.value = minValueFrom;
        }

        if (+this.sliderTwo.value < minValueTo) {
            this.sliderTwo.value = minValueTo;
        }

        this.slide();

        this.from.addEventListener("keyup", () => {
            if (+this.from.value > +this.to.value && +this.to.value > 0) {
                this.from.value = this.to.value;
                this.sliderOne.value = this.to.value;
            }

            this.fillColor();
        });

        this.from.addEventListener("change", () => {
            this.fillColor();
        });

        this.to.addEventListener("change", () => {
            this.fillColor();
        });

        this.to.addEventListener("input", () => {
            this.to.value = this.to.value.replaceAll(/^0(\d)|[^\d]/g, "");
        });

        this.from.addEventListener("input", () => {
            this.from.value = this.from.value.replaceAll(/^0(\d)|[^\d]/g, "");
        });

        this.sliderOne.addEventListener("change", (event) => {
            event.stopPropagation();
            this.from.dispatchEvent(new Event("change", {
                bubbles: true
            }));
            this.slide();
        }, {
            signal: this.abortController.signal
        });
        this.sliderOne.addEventListener("input", () => {
            this.slide();
        });

        this.sliderTwo.addEventListener("change", (event) => {
            event.stopPropagation();
            this.to.dispatchEvent(new Event("change", {
                bubbles: true
            }));
            this.slide();
        }, { signal: this.abortController.signal });
        this.sliderTwo.addEventListener("input", () => {
            this.slide();
        });
    }

    slide() {
        if (+this.sliderOne.value > +this.sliderTwo.value) {
            if (this.sliderTwo.value == this.sliderTwo.min) {
                this.from.value = "";
            } else {
                this.from.value = this.sliderTwo.value;
            }
            if (this.sliderOne.value == this.sliderTwo.max) {
                this.to.value = "";
            } else {
                this.to.value = this.sliderOne.value;
            }
        } else {
            if (this.sliderOne.value == this.sliderOne.min) {
                this.from.value = "";
            } else {
                this.from.value = this.sliderOne.value;
            }
            if (this.sliderTwo.value == this.sliderTwo.max) {
                this.to.value = "";
            } else {
                this.to.value = this.sliderTwo.value;
            }
        }

        this.fillColor();
    }

    fillColor() {
        const sliderTrack = this.querySelector("[data-price-range-track]");
        const sliderMaxValue = +this.sliderOne.max;

        const percent1 = (this.sliderOne.value / sliderMaxValue) * 100;
        const percent2 = (this.sliderTwo.value / sliderMaxValue) * 100;

        if (+this.sliderOne.value < +this.sliderTwo.value) {
            sliderTrack.style.background = `linear-gradient(to right, var(--tertiary-color) ${percent1}% , var(--primary-color) ${percent1}% , var(--primary-color) ${percent2}%, var(--tertiary-color) ${percent2}%)`;
        } else {
            sliderTrack.style.background = `linear-gradient(to right, var(--tertiary-color) ${percent2}% , var(--primary-color) ${percent2}% , var(--primary-color) ${percent1}%, var(--tertiary-color) ${percent1}%)`;
        }
    }
}

if (!window.customElements.get("price-range")) {
    window.customElements.define("price-range", PriceRange);
}

class FacetSort extends HTMLElement {
    constructor() {
        super();
        this.placeholderElements = this.querySelectorAll("[data-facet-sort-placeholder]");

        this.addEventListener("click", (event) => {
            if (event.target.closest("a")) {
                event.preventDefault();
                this.onValueChanged(event);
            }
        })

    }

    connectedCallback() {
        this.querySelectorAll("[data-dropdown-opener]").forEach(element => {
            if (openElements.has(element.id)) {
                element.open = true;
                openElements.delete(element.id);
            }
        });
    }

    onValueChanged(event) {
        const url = new URL(location.href);
        const sectionId = extractSectionId(event.target.closest(".shopify-section"));
        const sortOptionPlaceholder = event.target.innerText;
        url.searchParams.set("sort_by", event.target.href.split("?sort_by=")[1]);
        url.searchParams.set("section_id", sectionId);
        url.searchParams.delete("page");

        if (this.placeholderElements && this.placeholderElements.length) {
            this.placeholderElements.forEach(placeholderElement => {
                placeholderElement.innerText = `${window.translations.sort_by}: ${sortOptionPlaceholder}`;
            })
        }

        this.dispatchEvent(new CustomEvent("facet:update", {
            bubbles: true,
            detail: {
                url
            }
        }));
    }
};

if (!window.customElements.get("facet-sort")) {
    window.customElements.define("facet-sort", FacetSort);
}

class FacetLink extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.linkElement = this.querySelector("[data-facet-link-element]");

        this.linkElement.addEventListener("click", (e) => {
            this.onFacetUpdate(e);
        });
    }

    onFacetUpdate(event) {
        event.preventDefault();
        const sectionElement = event.target.closest(".shopify-section");
        const sectionId = extractSectionId(sectionElement),
            url = new URL(this.linkElement.href);
        url.searchParams.set("section_id", sectionId);

        this.dispatchEvent(new CustomEvent("facet:update", {
            bubbles: true,
            detail: {
                url
            }
        }));
    }
}

if (!window.customElements.get("facet-link")) {
    customElements.define("facet-link", FacetLink);
}

class FacetForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.formElement = this.querySelector("[data-facet-form-element]");

        this.formElement.addEventListener("change", (event) => {
            if (!event.target.name) {
                return null;
            }
            this.onFormChanged();
        });

        this.formElement.addEventListener("submit", (e) => {
            this.onFormSubmitted(e);
        });

        this.formElement.querySelectorAll("[data-dropdown-opener]").forEach(element => {
            if (openElements.has(element.id)) {
                element.open = true;
                openElements.delete(element.id);
            }
        })
    }

    buildUrl() {
        const searchParams = new URLSearchParams(new FormData(this.formElement))

        const url = new URL(this.formElement.action);
        url.search = "";
        searchParams.forEach((value, key) => url.searchParams.append(key, value));
        ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((optionToClear) => {
            if (url.searchParams.get(optionToClear) === "") {
                url.searchParams.delete(optionToClear);
            }
        });

        url.searchParams.set("section_id", this.formElement.getAttribute("data-section-id"));
        return url;
    }

    onFormChanged() {
        this.notEmpty = true

        this.formElement.dispatchEvent(new Event("submit", {
            cancelable: true
        }));
    }
    onFormSubmitted(event) {
        event.preventDefault();

        if (!this.notEmpty) {
            return;
        }

        this.formElement.dispatchEvent(new CustomEvent("facet:update", {
            bubbles: true,
            detail: {
                url: this.buildUrl()
            }
        }));

        this.notEmpty = false;
    }
}

if (!window.customElements.get("facet-form")) {
    customElements.define("facet-form", FacetForm)
}

class FocusTrap {
    constructor(container) {
        this.container = container;
        if (!this.container) return;

        this.selectors = [
            "summary",
            "a[href]",
            "button:enabled",
            "[tabindex]:not([tabindex^='-'])",
            "[draggable]",
            "area",
            "input:not([type=hidden]):enabled",
            "select:enabled",
            "textarea:enabled",
            "object",
            "iframe"
        ];

        this.init();
    }

    init() {
        document.addEventListener("keydown", (event) => {
            this.tabTrappingKey(event, this.container);
        });
    }

    getAllFocusableElements(parentElem) {
        const nodes = parentElem.querySelectorAll(this.selectors.join(','));
        const filterNegativeTabIndex = [];

        for (let i = 0; i < nodes.length; i++) {
            const tabindexAtr = parseInt(nodes[i].getAttribute('tabindex'), 10);

            if (!tabindexAtr || tabindexAtr > -1) {
                if (!nodes[i].closest(".hidden")) {
                    filterNegativeTabIndex.push(nodes[i])
                }
            }
        }

        return filterNegativeTabIndex
    }

    tabTrappingKey(event, parentElem) {
        const keyCode = event.which || event.keyCode

        if (keyCode !== 9) return

        const elements = this.getAllFocusableElements(parentElem);

        const first = elements[0];
        const last = elements[elements.length - 1];

        if (event.shiftKey) {
            if (document.activeElement === first) {
                last.focus();
                event.preventDefault();
            }
        } else {
            if (document.activeElement === last) {
                first.focus();
                event.preventDefault();
            }
        }
    }
}

class MediaModel extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.loadShopifyFeature();
    }

    loadShopifyFeature() {
        window.Shopify.loadFeatures([
            {
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXr.bind(this)
            },
            {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: () => {
                    const modelViewer = this.querySelector("model-viewer");

                    new window.Shopify.ModelViewerUI(modelViewer, {
                        focusOnPlay: true
                    })
                }
            }
        ])
    }

    setupShopifyXr() {
        if (!window.ShopifyXR) {
            document.addEventListener("shopify_xr_initialized", this.setupShopifyXr.bind(this));
        } else {
            const section = this.closest(".shopify-section");
            if (!section) {
                return null;
            }
            const models = JSON.parse(section.querySelector("[data-product-object]").innerHTML)["3d_media"];
            window.ShopifyXR.addModels(models);
            window.ShopifyXR.setupXRElements();
        }
    }

    launchXR() {
        const mediaId = parseInt(this.getAttribute("data-media-id"));
        const productTitle = this.getAttribute("data-product-title");

        return {
            model3dId: [mediaId],
            title: productTitle
        }
    }
}

if (!window.customElements.get("media-model")) {
    window.customElements.define("media-model", MediaModel);
}

class VariantSku extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.formId = this.getAttribute("data-form-id-id");
        this.form = document.forms[this.formId];

        if (!this.form) return;

        this.form.addEventListener("variant:changed", (event) => {
            if (event.detail.variant) {
                if (event.detail.variant.sku) {
                    const skuElement = this.querySelector("[data-product-sku]");
                    skuElement.innerHTML = event.detail.variant.sku;

                    if (this.classList.contains("hidden")) {
                        this.classList.remove("hidden")
                    }
                } else {
                    if (this.classList.contains("hidden")) return;

                    this.classList.add("hidden");
                }
            }
        });
    }
}

if (!window.customElements.get("variant-sku")) {
    window.customElements.define("variant-sku", VariantSku)
}

class ProductPrice extends HTMLElement {
    constructor() {
        super();

        this.priceElement = this.querySelector("[data-price]");
        this.compareAtPriceElement = this.querySelector("[data-compare-at-price]");
        this.unitPriceElement = this.querySelector("[data-unit-price]");
    }

    connectedCallback() {
        this.formId = this.getAttribute("data-form-id");
        this.form = document.forms[this.formId];

        if (this.form) {
            this.form.addEventListener("variant:changed", this.updateProductPrice.bind(this));
        }
    }

    updateProductPrice(event) {
        const variant = event.detail.variant;
        if (!variant) {
            return null;
        }

        this.priceElement.innerText = formatMoney(variant.price, window.price.money_format);

        if (variant.compare_at_price) {
            this.compareAtPriceElement.innerText = formatMoney(variant.compare_at_price, window.price.money_format);
            this.compareAtPriceElement.classList.remove("hidden");
        } else {
            this.compareAtPriceElement.classList.add("hidden");
        }
        if (variant.unit_price_measurement) {
            const reference_value = variant.unit_price_measurement.reference_value;
            const reference_unit = variant.unit_price_measurement.reference_unit;
            this.unitPriceElement.innerText = `${formatMoney(variant.unit_price)}/${reference_value}${reference_unit}`;
            this.unitPriceElement.classList.remove("hidden");
        } else {
            this.unitPriceElement.classList.add("hidden");
        }
    }
}

if (!window.customElements.get("product-price")) {
    window.customElements.define("product-price", ProductPrice)
}

class QuantitySelector extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.formId = this.getAttribute("data-form-id");
        this.form = document.forms[this.formId];
        this.abortController = new AbortController();
        this.inputElement = this.querySelector("quantity-input");
        this.inputFieldElement = this.querySelector("[data-product-quantity-input]")
        this.minusButton = this.querySelector("[data-product-counter-minus]");
        this.plusButton = this.querySelector("[data-product-counter-plus]");

        this.minusButton.addEventListener("click", () => {
            this.inputElement.quantity = this.inputElement.quantity - 1, {
                signal: this.abortController.signal
            }
            this.disableButtons();
        });
        this.plusButton.addEventListener("click", () => {
            this.inputElement.quantity = this.inputElement.quantity + 1, {
                signal: this.abortController.signal
            }
            this.disableButtons();
        });

        if (this.form) {
            this.form.addEventListener("variant:changed", this.onVariantChange.bind(this))
        }
    }

    disableButtons() {
        if (this.inputElement.quantity >= this.inputElement.maxQuantity) {
            this.plusButton.classList.add("disabled");
            this.plusButton.setAttribute("disabled", "disabled");
        } else {
            this.plusButton.classList.remove("disabled");
            this.plusButton.removeAttribute("disabled");
        }

        if (this.inputElement.quantity <= 1) {
            this.minusButton.classList.add("disabled");
            this.minusButton.setAttribute("disabled", "disabled");
        } else {
            this.minusButton.classList.remove("disabled");
            this.minusButton.removeAttribute("disabled");
        }
    }

    onVariantChange(event) {
        const variant = event.detail.variant;

        if (!variant) {
            return null;
        }

        if (variant.available) {
            if (variant.inventory_management && variant.inventory_policy === 'deny') {
                this.inputFieldElement.max = variant.inventory_quantity;
            } else {
                if (variant.inventory_quantity <= 0) {
                    this.inputFieldElement.removeAttribute("max");
                }
            }

            this.disableButtons();
            if (this.inputElement.quantity > this.inputElement.maxQuantity) {
                this.inputElement.quantity = variant.inventory_quantity;
            }
        } else {
            this.inputFieldElement.max = 1;
            this.inputElement.quantity = 1;
            this.disableButtons();
        }
    }
}

if (!window.customElements.get("quantity-selector")) {
    window.customElements.define("quantity-selector", QuantitySelector);
}
class QuantityInput extends HTMLElement {
    constructor() {
        super();

    }
    connectedCallback() {
        this.inputElement = this.querySelector("[data-product-quantity-input]");

        this.inputElement.addEventListener("input", () => {
            this.onValueInput();
        });

        this.inputElement.addEventListener("change", () => {
            this.onValueChanged();
        });

        this.quantitySelector = this.closest("quantity-selector");
    }

    get maxQuantity() {
        return parseInt(this.inputElement.max);
    }
    get quantity() {
        return parseInt(this.inputElement.value);
    }
    set quantity(quantity) {
        const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);

        if (quantity === "") {
            return;
        }

        if (!isNumeric || quantity < 0) {
            quantity = parseInt(quantity) || 1;
        }
        this.inputElement.value = Math.max(this.inputElement.min || 1, Math.min(quantity, this.inputElement.max || Number.MAX_VALUE)).toString();
    }

    onValueInput() {
        this.quantity = this.inputElement.value;
        this.quantitySelector.disableButtons();
    }

    onValueChanged() {
        if (this.inputElement.value === "") {
            this.quantity = 1;
        }
        this.quantitySelector.disableButtons();
    }
}

if (!window.customElements.get("quantity-input")) {
    window.customElements.define("quantity-input", QuantityInput);
}

class BuyButtons extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.errorMessage;
        this.errorMessageText;
        this.errorMessageIcon;

        this.buyButton = this.querySelector("[data-add-to-cart]");
        this.paymentButtons = this.querySelector("[data-payment-button]");
        this.addToCartText = this.querySelector("[data-add-to-cart-text]")
        this.formId = this.getAttribute("data-form-id");
        this.form = document.forms[this.formId];

        if (this.form) {
            this.errorMessage = this.form.querySelector("[data-error-message]");
            this.errorMessageText = this.errorMessage.querySelector("[data-error-message-text]");
            this.errorMessageIcon = this.errorMessage.querySelector("[data-error-message-icon]");

            this.form.addEventListener("submit", this.onFormSubmit.bind(this));
            this.form.addEventListener("variant:changed", this.onVariantChanged.bind(this));
        }
    }

    onVariantChanged(event) {
        this.errorMessage.classList.add("hidden");
        const variant = event.detail.variant;

        if (!variant) {
            this.buyButton.disabled = true;
            this.addToCartText.innerText = window.translations.product.buttons.unavailable;
            this.paymentButtons?.classList.add("hidden");

            return null;
        }

        if (!variant.available) {
            this.buyButton.disabled = true;
            this.addToCartText.innerText = window.translations.product.buttons.sold_out;
            this.paymentButtons?.classList.add("hidden");
        } else {
            this.buyButton.disabled = false;
            this.addToCartText.innerText = window.translations.product.buttons.add_to_cart;
            this.paymentButtons?.classList.remove("hidden");
        }
    }

    handleErrors(response) {
        if(!this.errorMessage) return;

        if (response && (response.errors || response.description)) {
            let errorsList = [];
    
            if (response.errors) {
                Object.entries(response.errors).forEach(([key, values]) => {
                    if (Array.isArray(values)) {
                        values.forEach((value) => {
                            errorsList.push(`${value}`);
                        });
                    } else {
                        errorsList.push(`${values}`);
                    }
                });
            }
    
            if (typeof response.description === 'object' && response.description !== null) {
                Object.entries(response.description).forEach(([key, values]) => {
                    if (Array.isArray(values)) {
                        values.forEach((value) => {
                            errorsList.push(`${value}`);
                        });
                    } else {
                        errorsList.push(`${values}`);
                    }
                });
            } else if (typeof response.description === 'string') {
                errorsList.push(response.description);
            }
    
            errorsList = [...new Set(errorsList)];
            
            errorsList.forEach((errorMessage) => {
                const errorItemHtml = this.createErrorItem(errorMessage);
                this.errorMessageText.appendChild(errorItemHtml);
            });
    
            this.errorMessage.classList.remove("hidden");
        }
    }

    createErrorItem(value) {
        const li = document.createElement("li");
        const span = document.createElement("span");
        const errorClone = this.errorMessageIcon.cloneNode(true);
        errorClone.classList.remove("hidden");
        span.innerText = value;
        li.appendChild(errorClone);
        li.appendChild(span);
        return li;
    }

    clearErrors() {
        if(!this.errorMessage) return;

        this.errorMessage.classList.add("hidden");
        this.errorMessageText.innerText = "";
    }

    async onFormSubmit(event) {
        event.preventDefault();
        const eventTarget = event.target;
        const formData = new FormData(eventTarget);
        
        const config = {
            method: "POST",
            headers: {
                'Accept': 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        }

        this.clearErrors();
        this.buyButton.disabled = true;

        if (!this.buyButton.classList.contains("loading")) this.buyButton.classList.add("loading")
        
        fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then((response) => {
                const cartItemsEl = document.querySelector("cart-items");

                if(!cartItemsEl) document.dispatchEvent(new CustomEvent("cart:updated"));

                if (response.status) {
                    this.handleErrors(response);
                    return;
                }

                document.dispatchEvent(new CustomEvent("product:added", { detail: { openButton: this.buyButton }}));
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.buyButton.classList.remove("loading")
                this.buyButton.disabled = false;
            });
    }
}

if (!window.customElements.get("buy-buttons")) {
    window.customElements.define("buy-buttons", BuyButtons);
}

class ProductInventory extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.formId = this.getAttribute("data-form-id");
        this.form = document.forms[this.formId];
        this.messageWrapper = this.querySelector("[data-quantity-wrapper]");
        if (this.form) {
            this.form.addEventListener("variant:changed", this.onVariantChanged.bind(this));
        }
    }

    onVariantChanged(event) {
        const variant = event.detail.variant;

        if (!variant || !this.messageWrapper) {
            return null;
        }

        if (variant.available) {
            if (variant.inventory_management && variant.inventory_policy === 'deny') {
                const messageSpan = `<span class="main-product__text main-product__text--tertiary">${window.translations.product.inventory.available.replace("[quantity]", variant.inventory_quantity)}</span>`;
                this.messageWrapper.innerHTML = window.translations.product.inventory.in_stock_quantity_html.replace("[quantity_code]", messageSpan);
            } else {
                if (variant.inventory_quantity <= 0) {
                    this.messageWrapper.innerHTML = window.translations.product.inventory.in_stock;
                }
            }
        } else {
            this.messageWrapper.innerHTML = window.translations.product.inventory.out_of_stock;
        }
    }
}

if (!window.customElements.get("product-inventory")) {
    window.customElements.define("product-inventory", ProductInventory);
}

class ProductOptions extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initElements();
        this.changeHistoryState = this.getAttribute("data-change-history-state");
        this.productJSON = this.closest(".shopify-section").querySelector("[data-product-object]")
        if (!this.productJSON) {
            return null;
        }
        this.product = JSON.parse(this.productJSON.innerHTML);
        this.currentVariant = this.product.current_variant;
        this.addEventListener("change", this.onOptionChange);
        this.formId = this.getAttribute("data-form-id");
        this.form = document.forms[this.formId];
        setTimeout(() => {
            this.form.dispatchEvent(new CustomEvent("variant:changed", {
                detail: {
                    variant: this.currentVariant
                }
            }));
        }, 25);

        this.productOptionInputs = this.formInputs.reduce(
            (options, input) => {
                const option = input.getAttribute("data-option");
                const inputs = options[option] || [];

                return {
                    ...options,
                    [option]: [...inputs, input]
                };
            }, {}
        );
        const selectedOptions = this.getSelectedOptions();

        this.disableUnavailableOptions(selectedOptions);
    }

    initElements() {
        this.formInputs = [...this.querySelectorAll("input:not([name='id'])")];
        this.selectedVariantId = this.querySelector("[name='id']");
    }

    onOptionChange(event) {
        const eventTarget = event.target;
        const dataOptionValue = eventTarget.getAttribute("data-option");
        const value = eventTarget.value;
        const selectedOptions = this.getSelectedOptions();
        this.currentVariant = this.getVariantsBySelectedOptions(selectedOptions);
        this.form.dispatchEvent(new CustomEvent("variant:changed", {
            detail: {
                variant: this.currentVariant
            }
        }));
        
        this.updateSelectedId(this.currentVariant);
        this.updateOptionLabel(dataOptionValue, value);
        this.disableUnavailableOptions(selectedOptions);
        if (this.changeHistoryState === "true") {
            this.updateBrowserHistory(this.currentVariant);
        }
    }
    updateSelectedId(variant) {
        if (!this.selectedVariantId || !variant) {
            return null;
        }

        this.selectedVariantId.value = variant.id;
    }

    getSelectedOptions() {
        const activeInputs = [...this.querySelectorAll("input:checked")];

        return activeInputs.reduce((options, input) => {
            const optionPosition = input.getAttribute("data-option");
            options[optionPosition] = input.value

            return options
        }, {});
    }

    getVariantsBySelectedOptions(selectedOptions) {
        const optionKeys = Object.keys(selectedOptions);

        return this.product.variants.find(variant => {
            return optionKeys.every(key => {
                return variant[key] === selectedOptions[key]
            })
        }) || null;
    }

    getAvailableValues(variants, selectedOptions) {
        const optionKeys = Object.keys(selectedOptions);
        const variantsAvailableToCombination = this.getAvailableToCombinationVariants(variants, selectedOptions)

        return Object.assign({},
            ...optionKeys.map(key => {
                return {
                    [key]: [...new Set(variantsAvailableToCombination.map(variant => {
                        return variant[key];
                    }))]
                }
            })
        )
    }

    getAvailableToCombinationVariants(variants, selectedOptions) {
        const optionKeys = Object.keys(selectedOptions);

        if (Object.keys(selectedOptions).length > 1) {
            return variants.filter(variant => {
                if (!variant.available) {
                    return null;
                }

                return optionKeys.some(key => {
                    return variant[key] === selectedOptions[key]
                })
            })
        } else {
            return variants.filter(variant => {
                if (!variant.available) {
                    return null;
                }

                return variant;
            })
        }
    }

    disableUnavailableOptions(selectedOptions) {
        if (!Object.keys(this.productOptionInputs).length) {
            return null;
        }

        const availableValues = this.getAvailableValues(this.product.variants, selectedOptions);

        Object.keys(this.productOptionInputs).forEach(option => {
            this.productOptionInputs[option].forEach(input => {
                const wrapper = input.closest('li');
                const label = wrapper.querySelector("label");

                if (label) {
                    label.classList.add("disabled");

                    if (availableValues[option] && availableValues[option].includes(input.value)) {
                        label.classList.remove("disabled");
                    }
                }
            })
        })
    }

    updateOptionLabel(optionIndex, newValue) {
        if (!optionIndex) {
            return null;
        }

        const optionLabel = this.querySelector(`[data-option-label="${optionIndex}"]`);
        if (!optionLabel) {
            return null;
        }
        optionLabel.innerText = newValue;
    }

    updateBrowserHistory(variant) {
        if (!variant) {
            return null;
        }

        const url = window.getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({
            path: url
        }, "", url);
    }
}

if (!window.customElements.get("product-options")) {
    window.customElements.define("product-options", ProductOptions)
}

class SellingPlanSelector extends HTMLElement {
    constructor() {
        super();
        this.currentVariant = "";
    }

    connectedCallback() {
        this.formId = this.getAttribute("data-form-id-id");
        this.form = document.forms[this.formId];
        this.currentVariantInput = this.querySelector("[data-current-variant-id]");
        
        if (!this.form) return;

        if (this.currentVariantInput) {
            this.currentVariantInput.value = +this.currentVariant.id;
        }

        this.updateSelectorDisplay(this.currentVariant);

        this.form.addEventListener("variant:changed", (e) => {
            this.currentVariant = e.detail.variant;

            if (this.currentVariant && this.currentVariantInput) {
                this.currentVariantInput.value = +this.currentVariant.id;
            }

            this.updateSelectorDisplay(this.currentVariant);
            this.showSelectedVariantGroup(this.currentVariant);

            const activePurchase = this.getActivePurchaseItem();
            const activePurchaseId = activePurchase?.getAttribute("data-selling-plan-id");
            
            this.updateSellingPlanInput(activePurchaseId);
            this.updatePrice(activePurchase);
        });

        this.addEventListener("change", (e) => {
            if (e.target.closest("[data-selling-plan]")) {
                const target = e.target.closest("[data-selling-plan]");

                let sellingPlanId;

                if (target.hasAttribute("data-selling-plan-id")) {
                    sellingPlanId = target.getAttribute("data-selling-plan-id");
                }

                this.updateSellingPlanInput(sellingPlanId);
                this.updatePrice(target);
            }
        })
    }

    getActivePurchaseItem() {
        return this.querySelector("[data-variant-group-list]:not(.hidden) [data-selling-plan]:checked");
    }

    updateSellingPlanInput(planId) {
        const currentSellingPlanInput = this.querySelector("[data-current-selling-plan]");
        
        if (planId) {
            currentSellingPlanInput.value = planId;
        } else {
            currentSellingPlanInput.value = "";
        }
    }

    updatePrice(target) {
        if (target) {
            if (target.hasAttribute("data-selling-plan-price") && target.hasAttribute("data-selling-plan-compare-at-price")) {
                const sellingPrice = target.getAttribute("data-selling-plan-price");
                const sellingCompareAtPrice = target.getAttribute("data-selling-plan-compare-at-price");
                this.renderNewPrice(sellingPrice, sellingCompareAtPrice);
            } else {
                const variantPrice = target.getAttribute("data-variant-price");
                const variantCompareAtPrice = target.getAttribute("data-variant-compare-at-price");
                this.renderNewPrice(variantPrice, variantCompareAtPrice);
            }
        }
    }

    renderNewPrice(price, compareAtPrice) {
        const priceWrapperEl = this.form.querySelector("product-price");

        if(!priceWrapperEl) return;

        const priceEl = priceWrapperEl.querySelector("[data-price]");
        const compareAtPriceEl = priceWrapperEl.querySelector("[data-compare-at-price]");

        priceEl.innerText = price;

        if (price !== compareAtPrice) {
            compareAtPriceEl.innerText = compareAtPrice;
            this.showElement(compareAtPriceEl, true);
        } else {
            priceEl.innerText = price;
            this.showElement(compareAtPriceEl, false);
        }
    }

    showElement(el, show) {
        if (!el) return;

        if (!el.classList.contains("hidden")) {
            el.classList.add("hidden");
        }

        if (show) {
            el.classList.remove("hidden");
        }
    }

    updateSelectorDisplay(currentVariant) {
        this.showElement(this, false);
        
        if(currentVariant) {
            const variantAllocations = currentVariant.selling_plan_allocations;

            if (variantAllocations && variantAllocations.length > 0) {
                this.showElement(this, true);
            }
        }
    }

    showSelector(show) {
        if (!this.classList.contains("hidden")) {
            this.classList.add("hidden");
        }

        if (show) {
            if (this.classList.contains("hidden")) {
                this.classList.remove("hidden");
            }
        }
    }

    showSelectedVariantGroup(currentVariant) {
        if(!currentVariant) return;

        const variantGroupList = this.querySelectorAll("[data-variant-group-list]");
        const variantAllocations = currentVariant.selling_plan_allocations;

        if (variantGroupList.length > 0) {
            [...variantGroupList].map(item => {
                if (!item.classList.contains("hidden")) {
                    item.classList.add("hidden");
                }

                if (variantAllocations && variantAllocations.length > 0) {
                    const variantId = item.getAttribute("data-variant-group-list");

                    if (+variantId === +currentVariant.id) {
                        item.classList.remove("hidden");
                    }
                }
            })
        }
    }
}

if (!window.customElements.get("selling-plan-selector")) {
    window.customElements.define("selling-plan-selector", SellingPlanSelector);
}

class PickupAvailability extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.formId = this.getAttribute("data-form-id");
        this.form = document.forms[this.formId];
        this.onVariantChange = this.onVariantChange.bind(this);

        if (this.form) {
            this.form.addEventListener("variant:changed", this.onVariantChange);
        }
    }

    disconnectedCallback() {
        this.form.removeEventListener("variant:changed", this.onVariantChange)
    }

    async onVariantChange(event) {
        const variant = event.detail.variant;

        if (!variant) {
            this.classList.add("hidden");
            return null;
        }
        this.classList.remove("hidden");
        const tempElement = document.createElement("div");
        const url = `${window.Shopify.routes.root}variants/${variant.id}/?section_id=pickup-availability`;
        const sectionResponse = await fetchWithCache(url);

        tempElement.innerHTML = sectionResponse;
        this.replaceChildren(...tempElement.querySelector("pickup-availability").childNodes);
    }
}

if (!window.customElements.get("pickup-availability")) {
    window.customElements.define("pickup-availability", PickupAvailability);
}

class CartQuantitySelector extends HTMLElement {
    constructor() {
        super();

        this.cartItems = this.closest("cart-items");
        this.cartItem = this.closest("[data-cart-item]");
    }

    connectedCallback() {
        this.abortController = new AbortController();
        this.inputElementContainer = this.querySelector("cart-quantity-input");
        this.minusButton = this.querySelector("[data-button-minus]");
        this.plusButton = this.querySelector("[data-button-plus]");

        this.debouncedOnChange = debounce(() => {
            this.changeCart();
        }, 500)

        this.minusButton.addEventListener("click", () => {
            if (this.inputElementContainer.quantity > 1) {
                this.inputElementContainer.quantity = this.inputElementContainer.quantity - 1, {
                    signal: this.abortController.signal
                }

                this.debouncedOnChange();
                this.disableButtonPlus();
            } else {
                this.inputElementContainer.quantity = this.inputElementContainer.quantity - 1;
                this.removeFromCartButton = this.cartItem.querySelector("[data-remove-from-cart-button]");

                if (this.removeFromCartButton) {
                    this.cartItems.removeFromCart(this.removeFromCartButton.href);
                }
            }
        });

        this.plusButton.addEventListener("click", () => {
            this.inputElementContainer.quantity = this.inputElementContainer.quantity + 1, {
                signal: this.abortController.signal
            }

            this.debouncedOnChange();
            this.disableButtonPlus();
        });
    }

    disableButtonPlus() {
        if (this.inputElementContainer.quantity >= this.inputElementContainer.maxQuantity) {
            this.plusButton.classList.add("disabled");
            this.plusButton.setAttribute("disabled", "disabled");
        } else {
            this.plusButton.classList.remove("disabled");
            this.plusButton.removeAttribute("disabled");
        }
    }

    changeCart() {
        this.variantId = this.cartItem.dataset.variantId;
        this.cartItems.onCartChange(this.variantId, this.inputElementContainer.quantity);
    }
}

if (!window.customElements.get("cart-quantity-selector")) {
    window.customElements.define("cart-quantity-selector", CartQuantitySelector);
}

class CartQuantityInput extends HTMLElement {
    constructor() {
        super();
        this.cartItems = this.closest("cart-items");
        this.cartItem = this.closest("[data-cart-item]");
        this.cartQuantitySelector = this.closest("cart-quantity-selector");
    }

    connectedCallback() {
        this.inputElement = this.querySelector("[data-cart-quantity-input]");

        this.inputElement.addEventListener("input", () => {
            this.onValueInput();
        });

        this.inputElement.addEventListener("change", () => {
            this.onValueChanged();
        });
    }

    get maxQuantity() {
        return parseInt(this.inputElement.max);
    }
    get quantity() {
        return parseInt(this.inputElement.value);
    }
    set quantity(quantity) {
        const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);

        if (quantity === "") {
            return;
        }

        if (!isNumeric) {
            quantity = parseInt(quantity) || 1;
        }

        this.inputElement.value = Math.max(this.inputElement.min || 0, Math.min(quantity, this.inputElement.max || Number.MAX_VALUE)).toString();
    }

    onValueInput() {
        this.quantity = this.inputElement.value;
        this.cartQuantitySelector.disableButtonPlus();
    }

    onValueChanged() {
        if (this.inputElement.value === "") {
            this.quantity = 1;
        }
        if (this.quantity >= 1) {
            this.cartQuantitySelector.debouncedOnChange();
        } else {
            this.removeFromCartButton = this.cartItem.querySelector("[data-remove-from-cart-button]");

            if (this.removeFromCartButton) {
                this.cartItems.removeFromCart(this.removeFromCartButton.href);
            }
        }
    }
}

if (!window.customElements.get("cart-quantity-input")) {
    window.customElements.define("cart-quantity-input", CartQuantityInput);
}
class CartItems extends HTMLElement {
    constructor() {
        super();

        this.section = this.closest(".shopify-section");
        this.sectionId = extractSectionId(this);

        document.addEventListener("product:added", (event) => {
            this.onCartUpdate();
            this.openButton = event.detail.openButton;
        });
    }

    onCartChange(variantId, quantity) {
        this.enableLoading(true);

        const body = JSON.stringify({
            id: variantId,
            quantity: quantity
        });

        fetch(window.Shopify.routes.root + 'cart/change.js', {
            ...fetchConfig(),
            ...{ body }
        })
        .then(() => {
            this.onCartUpdate();
        })
        .catch(e => {
            console.error(e);
        });
    }

    onCartUpdate() {
        this.enableLoading(true);

        fetch(`${window.routes.root_url}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const cartItemsHtml = html.querySelector('cart-items');
                this.innerHTML = cartItemsHtml.innerHTML;

                const cartSection = cartItemsHtml.closest(".shopify-section");
                const priceValue = cartSection.querySelector("[data-cart-price]");
                const cartCountInput = cartSection.querySelector("[data-cart-item-count]");
                const discountApplicationValue = cartSection.querySelector("[data-cart-discount-application]");
                const cartInfoContainer = this.section.querySelector("[data-cart-info-container]");
                const cartHeader = this.section.querySelector("[data-cart-info-header]");
                const shippingEstimator = cartSection.querySelector(".shipping-estimator");
                
                if (shippingEstimator) this.updateElementInnerHtml(shippingEstimator.innerHTML, ".shipping-estimator", false);

                this.updateElementInnerHtml(priceValue.innerHTML, "[data-cart-price]");

                if (discountApplicationValue && discountApplicationValue.innerHTML !== "") {
                    this.updateElementInnerHtml(discountApplicationValue.innerHTML, "[data-cart-discount-application]", false);
                } else {
                    this.updateElementInnerHtml("", "[data-cart-discount-application]", true);
                }

                if (cartCountInput.value > 0) {
                    this.classList.remove("empty")

                    if (cartInfoContainer) cartInfoContainer.classList.remove("hidden")
                    if (cartHeader) cartHeader.classList.remove("hidden")
                } else {
                    if (!this.classList.contains("empty")) this.classList.add("empty")
                    if (cartInfoContainer && !cartInfoContainer.classList.contains("hidden")) cartInfoContainer.classList.add("hidden")
                    if (cartHeader && !cartHeader.classList.contains("hidden")) cartHeader.classList.add("hidden")
                }

                this.enableLoading(false);

                document.dispatchEvent(new CustomEvent("modals:open", {
                    detail: {
                        modalId: "cart-drawer--modal",
                        openButton: this.openButton,
                    }
                }));

                document.dispatchEvent(new CustomEvent("cart:updated"))
            })
            .catch(e => {
                console.error(e);
                this.enableLoading(false);
            });
    }

    updateElementInnerHtml(value, selector, hideOnEmpty) {
        this.element = this.section.querySelector(selector);

        if (!this.element) return;

        this.element.innerHTML = value;

        if (hideOnEmpty === true) {
            if (!this.element.classList.contains("hidden")) {
                this.element.classList.add("hidden");
            }
        } else {
            if (this.element.classList.contains("hidden")) {
                this.element.classList.remove("hidden");
            }
        }
    }

    removeFromCart(url) {
        this.enableLoading(true);

        fetch(url).then(() => {
            this.onCartUpdate();
        }).catch(e => {
            console.error(e);
        });
    }

    enableLoading(enable) {
        this.loader = this.section.querySelector("[data-loader-element]");

        if (!this.loader) return;

        if (enable === true) {
            if (this.loader.classList.contains("show")) return;

            this.loader.classList.add("show");
        } else {
            if (!this.loader.classList.contains("show")) return;

            this.loader.classList.remove("show");
        }
    }
}

if (!window.customElements.get("cart-items")) {
    window.customElements.define("cart-items", CartItems);
}

class CartLinkButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.cartItems = this.closest(".shopify-section").querySelector("cart-items");

        if (!this.cartItems) return;

        this.linkElement = this.querySelector("[data-remove-from-cart-button]");
        this.linkElement.addEventListener("click", (e) => {
            e.preventDefault();

            this.cartItems.removeFromCart(this.linkElement.href);
        });
    }
}

if (!window.customElements.get("cart-link-button")) {
    window.customElements.define("cart-link-button", CartLinkButton);
}

class CartInfo extends HTMLElement {
    constructor() {
        super();
        this.detailsList = this.querySelectorAll("details");
        this.isDrawer = false;
        this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
        this.drawerCheck();
        this.removeTabIndexNav();

        [...this.detailsList].forEach(detailsItem => {
            detailsItem.addEventListener("toggle", this.handleToggle);
        });
    }

    disconnectedCallback() {
        [...this.detailsList].forEach(detailsItem => {
            detailsItem.removeEventListener("toggle", this.handleToggle);
        });
    }

    handleToggle(event) {
        const infoItem = event.target.closest("[data-cart-info-item]");

        this.calculateHeight();

        if (event.target.open) {
            [...this.detailsList].map(item => {
                if (item !== event.target) {
                    item.open = false;
                }
            });

            this.updateTabIndexes(infoItem, true);

            setTimeout(() => {
                event.target.scrollIntoView({ block: "start", behavior: "smooth" });
            }, 300);
        } else {
            this.updateTabIndexes(infoItem, false);
        }
    }

    drawerCheck() {
        const drawer = this.closest("modal-container[data-modal-id='cart-drawer--modal']");
        
        if (drawer) {
            this.isDrawer = true;
        }
    }

    updateTabIndexes(infoItem, focus) {
        if (this.isDrawer) {
            const selectors = [
                "summary",
                "a[href]",
                "button:enabled",
                "[tabindex]:not([tabindex^='-'])",
                "[draggable]",
                "area",
                "input:not([type=hidden]):enabled",
                "select:enabled",
                "textarea:enabled",
                "object",
                "iframe"
            ];
    
            const focusableItems = infoItem.querySelectorAll(`${selectors.map(selector => `.cart-info__item-content ${selector}`)}`);
    
            [...focusableItems].map(focusableItem => focus ? focusableItem.removeAttribute("tabindex"): focusableItem.setAttribute("tabindex", -1));
        }
    }

    removeTabIndexNav() {
        [...this.detailsList].forEach(details => {
            const infoItem = details.closest("[data-cart-info-item]");
            this.updateTabIndexes(infoItem, false);
        });
    }

    calculateHeight() {
        const infoItems = this.querySelectorAll("[data-cart-info-item]");

        [...infoItems].map(item => {
            const content = item.querySelector("[data-cart-info-item-content]");
            item.style.cssText = `--cart-info-height: ${content.offsetHeight}px;`;
        })
    }
}

if (!window.customElements.get("cart-info")) {
    window.customElements.define("cart-info", CartInfo)
}

class CustomSelect extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const list = this.querySelector(".dropdown__list");

        this.addEventListener("click", (event) => {
            if (!list.classList.contains("dropdown__list--open")) {
                list.classList.add("dropdown__list--open");
                list.classList.remove("hidden");
            }

            const eventTarget = event.target;

            if (eventTarget.closest(".dropdown__list-item")) {
                this.style.pointerEvents = "none";

                if (list.classList.contains("dropdown__list--open")) {
                    list.classList.remove("dropdown__list--open");
                    list.classList.add("hidden");
                }

                this.style.pointerEvents = "all";
            }
        });

        this.addEventListener("mouseenter", () => {
            if (!list.classList.contains("dropdown__list--open")) {
                list.classList.add("dropdown__list--open");
                list.classList.remove("hidden");
            }
        });

        this.addEventListener("mouseleave", () => {
            if (list.classList.contains("dropdown__list--open")) {
                list.classList.remove("dropdown__list--open");
                list.classList.add("hidden");
            }
        });
    }
}

if (!window.customElements.get("custom-select")) {
    window.customElements.define("custom-select", CustomSelect);
}

class CartDrawerChecker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const isDrawer = document.querySelector(".cart-drawer") ? true : false;

        if (!isDrawer) {
            const template = this.querySelector("template");
            this.replaceChildren(template.content.firstElementChild.cloneNode(true));
        }
    }
}

if (!window.customElements.get("cart-drawer-checker")) {
    window.customElements.define("cart-drawer-checker", CartDrawerChecker);
}

class ProductTabs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.showContent();

        this.addEventListener("click", (event) => {
            const eventTarget = event.target;

            if (eventTarget.closest("[data-tab-target]")) {
                event.preventDefault();
                const targetElement = eventTarget.closest("[data-tab-target]");
                this.setActiveTab(targetElement);
                this.showContent();
            }
        });
    }

    showContent() {
        const activeTab = this.querySelector("[data-tab-target].active");
        const contents = this.querySelectorAll("[data-tab-target-content]");
        const collectionHandle = activeTab.getAttribute("data-tab-target");

        [...contents].map((item => item.classList.remove("active")));

        const activeContentElement = this.querySelector(`[data-tab-target-content="${collectionHandle}"]`);

        if (!activeContentElement.classList.contains("active")) {
            activeContentElement.classList.add("active")
        }

        this.updateAosAnimation();
    }

    updateAosAnimation() {
        const productCards = this.querySelectorAll(".products-with-tabs__tab-content.active .aos-animate");

        [...productCards].map(card => {
            card.classList.remove("aos-animate");

            setTimeout(() => {
                card.classList.add("aos-animate");
            }, 0)
        })
    }

    setActiveTab(element) {
        const tabList = this.querySelectorAll("[data-tab-target]");
        [...tabList].map((item => item.classList.remove("active")));

        if (element && !element.classList.contains("active")) {
            element.classList.add("active")
        }
    }
}

if (!window.customElements.get("product-tabs")) {
    window.customElements.define("product-tabs", ProductTabs)
}

class StickyNormalizer {
    constructor(normalize) {
        this.normalize = normalize;
        this.stickyList = document.querySelectorAll("[data-sticky-element]");
        this.normalizeSticky();

        const debouncedOnResize = debounce(() => {
            this.normalize = false;
            this.normalizeSticky();
        }, 300);

        window.addEventListener("resize", debouncedOnResize)
    }

    normalizeSticky() {
        this.stickyList.forEach(item => {
            const wrapper = item.closest("[data-sticky-wrapper]");

            if (this.normalize === true) {
                if (window.innerWidth >= 992) {
                    wrapper.style.cssText = "position: relative;";
                    const width = window.getComputedStyle(item).width;
                    const height = window.getComputedStyle(item).height;
                    const scrollTop = item.offsetTop;

                    item.style.cssText = `position: absolute; top: ${scrollTop}px; width: ${width}; height: ${height}`;
                } else {
                    wrapper.style.cssText = ""
                    item.style.cssText = ``;
                }
            } else {
                wrapper.style.cssText = ""
                item.style.cssText = ``;
            }
        })
    }
}

class QuickViewOpenButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.buttonElement = this.querySelector("[data-quick-view-open-button]");
        this.quickViewModal = document.querySelector("[data-quick-view]");

        if (!this.quickViewModal) return;

        this.quickViewModalSectionId = extractSectionId(this.quickViewModal);
        this.previousHandle = this.quickViewModal.getAttribute("data-previous-handle");

        this.buttonElement.addEventListener("click", (e) => {
            this.fetchProductData(e);
        });
    }

    async fetchProductData(event) {
        document.dispatchEvent(new CustomEvent("modals:open", {
            detail: {
                modalId: "product-preview-modal-window",
                openButton: this.buttonElement
            }
        }));

        const eventTarget = event.target;
        const handle = eventTarget.getAttribute("data-product-handle") || null;

        if (!handle || !this.quickViewModal) {
            return null;
        }

        if (document.documentElement.classList.contains("shopify-design-mode")) {
            this.enableLoading(true);
        } else {
            if (this.previousHandle != handle) {
                this.enableLoading(true);
            } else {
                return null;
            }
        }

        var _url = eventTarget.getAttribute("data-product-url");

        if (_url.indexOf("?") > -1) {
            _url = _url.split("?");
            _url = _url[0];
        }

        const url = `${_url}?section_id=${this.quickViewModalSectionId}`;
        const response = await fetchWithCache(url);
        const tempElement = new DOMParser().parseFromString(response, "text/html").querySelector(".shopify-section");
        const quickViewContent = this.quickViewModal.querySelector("[data-quick-view-content]");

        quickViewContent.innerHTML = tempElement.querySelector("[data-quick-view-content]").innerHTML;

        if (window.Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
        }

        document.dispatchEvent(new CustomEvent("share:init"));

        this.enableLoading(false);
    }

    enableLoading(enable) {
        this.loader = this.quickViewModal.querySelector("[data-loader-element]");

        if (!this.loader) return;

        if (enable === true) {
            if (this.loader.classList.contains("show")) return;

            this.loader.classList.add("show");
        } else {
            if (!this.loader.classList.contains("show")) return;

            this.loader.classList.remove("show");
        }
    }
}

if (!window.customElements.get("quick-view-button")) {
    window.customElements.define("quick-view-button", QuickViewOpenButton);
}

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const section = this.closest(".shopify-section");

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    const isBlank = recommendations.querySelectorAll(".swiper-slide").length <= 0;

                    if (recommendations && recommendations.innerHTML.trim().length && !isBlank) {
                        this.innerHTML = recommendations.innerHTML;

                        if (section && section.classList.contains("hidden")) {
                            section.classList.remove("hidden");
                        }
                    } else {
                        if (section && !section.classList.contains("hidden")) {
                            section.classList.add("hidden");
                        }
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }

        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 300px 0px'
        }).observe(this);
    }
}

if (!window.customElements.get("product-recommendations")) {
    window.customElements.define('product-recommendations', ProductRecommendations);
}

class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            this.fetchSection();
            observer.unobserve(this);
        }

        this.addToRecentlyViewedProducts();

        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 300px 0px'
        }).observe(this);
    }

    addToRecentlyViewedProducts() {
        const currentId = +window?.meta?.product?.id;
        const viewedItems = this.getCookieValue("theme:viewed-products=");

        if (!currentId) {
            return;
        }

        if (!viewedItems) {
            document.cookie = `theme:viewed-products=${currentId}; path=/`;
        } else {
            const value = `${currentId}`;
            const newViewedItems = [value].concat(viewedItems.split(",").filter((item) => item !== value));

            document.cookie = `theme:viewed-products=${newViewedItems.join(",")}; path=/`;
        }
    }

    getRecentlyViewedProducts() {
        const currentId = +window?.meta?.product?.id;
        const value = currentId;
        const recentlyViewed = this.getCookieValue("theme:viewed-products=");
        const items = recentlyViewed
            .split(",")
            .filter((item) => {
                return item;
            })
            .map((item) => parseInt(item));

        if (window?.meta?.page.pageType !== "product") {
            return items;
        }

        return items.filter((item) => {
            return item !== value;
        });
    }

    async fetchSection() {
        const items = this.getRecentlyViewedProducts();
        const section = this.closest(".shopify-section")
        let searchQueryString = Array.from(items.values(), (item) => `id:${item}`).join(" OR ");
        let searchQueryUrl = `${window.Shopify.routes.root}search?type=product&q=${searchQueryString}&section_id=${extractSectionId(section)}`
        const response = await fetch(searchQueryUrl, {
            priority: "low"
        });
        const responseBody = await response.text();
        const tempDiv = new DOMParser().parseFromString(responseBody, "text/html")
        const recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");

        this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);

        this.sliderComponent = this.querySelector("slider-component");

        if (this.sliderComponent) {
            this.sliderComponent.initSwiper();
        }

        if (recentlyViewedProductsElement.childElementCount === 0) {
            section.remove();
        }
    }

    getCookieValue(name) {
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();

            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }

        return null;
    }
}

if (!window.customElements.get("recently-viewed-products")) {
    window.customElements.define('recently-viewed-products', RecentlyViewedProducts);
}

function WriteScrollbarWidth() {
    const value = window.innerWidth - document.documentElement.clientWidth;
    window.scrollBarWidth = value;
}

document.addEventListener("DOMContentLoaded", WriteScrollbarWidth);

if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => {
        if (e.target.querySelector("before-after-image")) {
            if (!window.customElements.get("before-after-image")) {
                window.customElements.define("before-after-image", BeforeAfterImage);
            }
        }
    })
}
